import type { ReactNode } from 'react';

import type { Step } from 'react-joyride';

export enum TutorialSegmentId {
  aires = 'aires',
  loans = 'loans',
  shares = 'shares',
  pfc = 'pfc',
  finish = 'finish',
}

export type TutorialMappingTab = TutorialSegmentId.loans | TutorialSegmentId.shares | TutorialSegmentId.pfc;

export type MappingTabCounts = {
  loans: number;
  shares: number;
  pfc: number;
};

export type UnmappedCounts = MappingTabCounts;

export type MappingTotals = MappingTabCounts;

export type TutorialMappingCounts = {
  counts: UnmappedCounts;
  totals: MappingTotals;
};

export type SegmentBuildContext = {
  counts: UnmappedCounts;
  totals: MappingTotals;
  hasCompletedAiresRow: boolean;
};

export type TutorialStepData = {
  segmentRoute?: string;
  desiredMenuTab?: TutorialMappingTab | null;
  desiredBulkSelectTab?: TutorialMappingTab | null;
  segmentLabel?: string;
  segmentStepIndex?: number;
  segmentStepTotal?: number;
};

export type TutorialStep = Step & {
  data?: TutorialStepData;
};

export type TutorialSegment = {
  id: TutorialSegmentId;
  route: string;
  buildSteps: (ctx: SegmentBuildContext) => TutorialStep[];
};

export type TutorialContextValue = {
  isActive: boolean;
  hasSeenTutorial: boolean;
  moreActionsTab: TutorialMappingTab | null;
  bulkSelectTab: TutorialMappingTab | null;
  startTutorial: () => void;
  stopTutorial: () => void;
  markAsSeen: () => void;
  setMoreActionsTab: (tab: TutorialMappingTab | null) => void;
  setBulkSelectTab: (tab: TutorialMappingTab | null) => void;
};

export type FinishModalState = {
  isOpen: boolean;
  onClose: () => void;
};

export type CoachMarkExtraProps = {
  segmentLabel?: string;
  segmentStepIndex?: number;
  segmentStepTotal?: number;
  whyItMatters?: ReactNode;
};
